import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import NetworkInvitePage from "@/pages/NetworkInvitePage";

export const Route = createFileRoute("/network-invite")({
  head: () => pageHead("AI Innovation Network Invitation", "Accept your invitation to join the AI Innovation Network — a community of AI engineers, practitioners, and enthusiasts.", "/network-invite", true),
  component: NetworkInvitePage,
});
